import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DoctorProfileService } from '../../../core/services/doctor-profile.service';
import { User } from '../../../core/models/user.model';
import { Clinic } from '../../../core/models/clinic.model';
import { Doctor } from '../../../core/models/doctor.model';

@Component({
  selector: 'app-personal-profile',
  imports: [CommonModule, FormsModule],
  templateUrl: './personal-profile.html',
  standalone: true,
  styleUrl: './personal-profile.scss',
})
export class PersonalProfile implements OnInit {
  profile: User = {
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    gender: null as any,
    title: null as any,
    role: '',
    currentActiveRole: '',
    roles: [],
  };

  doctorDetails: Doctor | null = null;
  loading = false;
  saving = false;
  creatingClinic = false;
  canCreateClinic = false;
  clinicCreationError = '';
  successMessage = '';
  errorMessage = '';
  clinic: Clinic = {
    name: '',
    practiceNumber: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    city: '',
    postalCode: '',
  };

  constructor(private doctorProfileService: DoctorProfileService) {}

  ngOnInit(): void {
    this.loadProfile();
    this.loadClinicCreationEligibility();
  }

  private loadClinicCreationEligibility(): void {
    this.doctorProfileService.canCreateClinic().subscribe({
      next: (canCreate) => (this.canCreateClinic = canCreate),
      error: () => (this.canCreateClinic = false),
    });
  }

  loadProfile(): void {
    this.loading = true;

    this.doctorProfileService.getUserProfile().subscribe({
      next: (response) => {
        this.profile = response;
        this.loading = false;
      },
      error: (error) => {
        console.error(error);
        this.errorMessage = 'Failed to load profile details.';
        this.loading = false;
      },
    });

    this.doctorProfileService.getDoctorProfileDetails().subscribe({
      next: (doctor) => {
        this.doctorDetails = doctor;
      },
      error: () => {
        this.doctorDetails = null;
      },
    });
  }

  saveProfile(): void {
    this.saving = true;
    this.successMessage = '';
    this.errorMessage = '';

    this.doctorProfileService.updateUserProfile(this.profile).subscribe({
      next: (response) => {
        this.profile = response;
        this.successMessage = 'Profile updated successfully.';
        this.saving = false;
      },
      error: (error) => {
        console.error(error);
        this.errorMessage = 'Failed to update profile.';
        this.saving = false;
      },
    });
  }

  createClinic(): void {
    this.clinicCreationError = '';
    if (
      !this.clinic.name.trim() ||
      !this.clinic.practiceNumber?.trim() ||
      !this.clinic.addressLine1.trim() ||
      !this.clinic.city.trim() ||
      !this.clinic.postalCode.trim()
    ) {
      this.clinicCreationError = 'Complete all required practice details.';
      return;
    }

    this.creatingClinic = true;
    this.doctorProfileService.createClinic(this.clinic).subscribe({
      next: () => {
        this.creatingClinic = false;
        this.canCreateClinic = false;
        this.successMessage = 'Clinic created and submitted for review.';
      },
      error: (error) => {
        this.creatingClinic = false;
        this.clinicCreationError = error?.error?.message || 'Failed to create clinic.';
      },
    });
  }
}
